import { Button } from "primereact/button";

export function ShoutOutBannerCarousel(props: any) {
  const handleClick = () => {
    window.open("https://ttec.awardco.com/", "_blank");
  };

  return (
    <div
      className="card border-0 mb-0 pb-0"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      {/* DESKTOP IMAGE */}
      <img
        src={props.web_url}
        className="w-100 img-fluid desktopImage"
        alt="Reach For Amazing Tool"
      />
      {/* MOBILE IMAGE */}
      <img
        src={props.mobile_url}
        className="w-100 img-fluid mobileImage"
        alt="Reach For Amazing Tool"
      />
      {/* OVERLAY CONTENT */}
      <div className="card-img-overlay">
        {/* Button Bottom Right */}
        <div
          className="position-absolute"
          style={{
            bottom: "20px",
            right: "20px",
            zIndex: 5,
          }}
        >
          <Button
            className="me-0 text-white text-start d-block"
            style={{
              backgroundColor: "#0d6efd",
              color: "white",
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "5px",
              zIndex: 3,
              pointerEvents: "none", // Prevents double open on button click
            }}
          >
            Recognize a Colleague Today!
          </Button>
        </div>
      </div>
    </div>
  );
}
